import axios from "axios"
import library from "../../../utils/Library"

export const getAllNotificationTypesEAuthz = async () => {
  const TOKEN = sessionStorage.getItem("token")
  const URL =
    library.getBaseAPIUrl("global_notification") +
    "/getAllNotificationTypesEAuthz"

  return await axios({
    url: URL,
    method: "GET",
    headers: {
      Authorization: `Bearer ${TOKEN}`,
    },
  })
}
